/** Tests an response against a {@link CachePredicateObject}. */
export async function testCachePredicate(response, predicate) {
    var _a;
    if (typeof predicate === 'function') {
        return predicate(response);
    }
    const { statusCheck, responseMatch, containsHeaders } = predicate;
    if ((statusCheck && !(await statusCheck(response.status))) ||
        (responseMatch && !(await responseMatch(response)))) {
        return false;
    }
    if (containsHeaders) {
        for (const header in containsHeaders) {
            const predicate = containsHeaders[header];
            if (predicate &&
                !(await predicate(
                // Axios uses lowercase headers, but if for some reason it doesn't, we should
                // still be able to match.
                (_a = response.headers[header.toLowerCase()]) !== null && _a !== void 0 ? _a : response.headers[header]))) {
                return false;
            }
        }
    }
    return true;
}
